<script>
	import { group } from 'd3-array';
	import Scroller from './helpers/Scroller.svelte';
	import data from '../data/data.csv';
	import copy from '../data/copy.json';

	const copyOrder = [
		'Intro',
		'Establishment',
		'Built-something-new',
		'Politics',
		'Still-in-government',
		'Media',
		'Anti-Trump',
		'Low-profile',
		'Off-the-grid',
		'Outro',
	];

	const hasImages = [
		'Intro',
		'Establishment',
		'Built-something-new',
		'Politics',
		'Still-in-government',
		'Media',
		'Anti-Trump',
		'Low-profile',
		'Off-the-grid',
	];

	let count;
	let index = 0;
	let offset = 0.1;
	let progress;
	let top = 0; // 0 - 1
	let threshold = 1; // 0 - 1
	let bottom = 1; // 0 - 1

	const sorted = data
		.sort(
			(a, b) =>
				copyOrder.indexOf(a.subcategory.replace(/ /g, '-')) -
				copyOrder.indexOf(b.subcategory.replace(/ /g, '-'))
		)
		.map((d, i) => {
			return {
				...d,
				idx: i,
			};
		});

	const grouped = group(sorted, (d) => d.subcategory.replace(/ /g, '-'));
	var newPastures = Array.from(grouped).slice(1, 3).reverse();
	var politicalPastures = Array.from(grouped).slice(6, 8);
	var antiTrump = Array.from(grouped).slice(0, 1);
	var media = Array.from(grouped).slice(4, 5);
	var changeofPastures = media.concat(antiTrump);
	var lowProfile = Array.from(grouped).slice(3, 4);
	var offTheGrid = Array.from(grouped).slice(5, 6);
	var hiddenPastures = lowProfile.concat(offTheGrid);
	const groupedFinal = new Map(
		newPastures.concat(politicalPastures, changeofPastures, hiddenPastures)
	);
	const scrollNums = new Map(
		Array.from(groupedFinal).map((g) => [g[0], g[1][0].idx])
	);

	$: active = copyOrder[index];
	$: firstInstance = scrollNums.get(active) - 1;
	$: typeTotal = groupedFinal.get(active)
		? groupedFinal.get(active).length
		: 0;
</script>

<div class="scrollyGraphic">
	<Scroller
		{top}
		{threshold}
		{bottom}
		bind:count
		bind:index
		bind:offset
		bind:progress
	>
		<div slot="background">
			<!-- <div class="background-content"> -->
			<div class="background-grid">
				{#each sorted as d, i}
					<svg
						class="user {d.subcategory
							.replace(/ /g, '-')
							.toLowerCase()} step-{index}"
						class:hide={index == 0 || i > firstInstance + typeTotal}
						class:low-opacity={i < firstInstance + 1}
						id="person"
						data-name="l1"
						xmlns="http://www.w3.org/2000/svg"
						viewBox="0 0 406.87 1033.17"
						><defs
							><style>
								.fill {
									fill: #e6e6e6;
								}
							</style></defs
						><path
							class="fill"
							d="M548.78,1116.59c-21.93,0-40.25-16.86-41.72-38.39L483.22,728.86c-38.25-6.57-65.69-38.26-68.64-81.54l-17.8-260.79a95,95,0,0,1,94.74-101.42h217a95,95,0,0,1,94.74,101.43L785.41,647.33c-2.86,41.83-28.94,73.07-65.48,80.86l-23.89,350c-1.47,21.52-19.79,38.38-41.72,38.38Z"
							transform="translate(-396.56 -83.41)"
						/><path
							class="fill"
							d="M600.33,295A105.79,105.79,0,1,1,706.11,189.19,105.9,105.9,0,0,1,600.33,295Z"
							transform="translate(-396.56 -83.41)"
						/></svg
					>
				{/each}
			</div>
		</div>

		<div slot="foreground">
			{#each copyOrder as graf}
				<section>
					<div class="step typography">
						{#if hasImages.includes(graf)}
							<div class="img-wrapper">
								<img
									src="https://tbimedia.s3.us-east-1.amazonaws.com/bistudios/_00/dev_edit/graphics/2021/06/2021-06-trump-alumni/assets/images/{graf}.png"
									alt="Randomly selected portraits of members from the {graf} grouping"
									loading="lazy"
								/>
							</div>
						{/if}
						<p class="copy">{@html copy[graf]}</p>
					</div>
				</section>
			{/each}
		</div>
	</Scroller>
</div>

<style lang="scss">
	[slot='background'] {
		display: flex;
		justify-content: center;
		align-items: center;
		height: calc(100vh - 71px - 100px);
		margin-top: calc(71px + 50px);
		width: 55%;
		font-size: 16px;
		overflow: hidden;
		.background-content {
			font-size: 1.4em;
			overflow: hidden;
			padding: 0;
			height: 100%;
			display: flex;
			align-items: center;
		}
	}

	[slot='foreground'] {
		pointer-events: none;
		max-width: 640px;
		margin: 0 auto;
		font-size: 16px;
		section {
			pointer-events: all;
			height: 80vh;
			padding: 1em;
			margin: 0 0 2em 0;
			font-family: var(--sans);
			margin: 0 auto max(80%, 20vh);
			&:last-of-type {
				height: 50%;
				margin-bottom: 0;
			}
			&:first-of-type {
				margin-top: 75px;
			}
			&:first-of-type,
			&:last-of-type {
				.step p:first-of-type {
					margin-top: 2.15rem !important;
				}
			}
		}
		.step {
			box-sizing: border-box;
			padding: 1em;
			background-color: hsla(0, 0%, 100%, 0.9);
			backdrop-filter: blur(5px);
			width: calc(45% - 1em);
			margin-left: calc(55% + 1em);
			border: 1px solid #333;
			border-radius: 2px;
			pointer-events: auto;
			position: relative;

			p {
				font-size: 1.25rem;
				// background-color: hsla(0, 0%, 100%, 0.7);
				backdrop-filter: blur(4px);
				&:first-of-type {
					margin-top: 4rem;
				}
			}
		}
	}

	.img-wrapper {
		position: absolute;
		top: -3em;
		left: 0;
		right: 0;
		text-align: center;
		img {
			width: 100%;
			max-width: 300px;
			margin: 0 auto;
		}
	}

	@media screen and (max-width: 550px) {
		[slot='background'] {
			width: 100%;
		}
		[slot='foreground'] {
			section {
				margin: 0 auto 50vh;
				height: 100vh;
				&:last-of-type {
					height: 200%;
					margin-bottom: 20vh;
				}
			}
			.step {
				width: 100%;
				margin: 0 auto;
			}
		}
	}
</style>
